import { useState, useEffect, useCallback } from 'react';
import { API_URL } from '../config';

/**
 * Log a notification/action to activity_log (fire-and-forget).
 *
 * @param {object} payload
 * @param {string}  payload.action_type           — 'slot_link_sent' | 'video_link_sent' | 'video_approved' | 'video_uploaded' | …
 * @param {number}  [payload.id_contact_emitter]  — admin/user qui déclenche
 * @param {number}  [payload.id_contact_receiver] — contact ciblé
 * @param {number}  [payload.id_event]
 * @param {number}  [payload.id_conf_event]
 * @param {object}  [payload.metadata]            — données libres {email, channel, url, youtube_id, …}
 */
export const logActivity = (payload) => {
    return fetch(`${API_URL}?action=createActivityLog`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    }).catch(() => { /* silencieux — le log ne doit jamais bloquer l'UX */ });
};

/**
 * Hook pour récupérer l'historique d'activité.
 *
 * @param {object} filters
 * @param {number}  [filters.id_event]
 * @param {number}  [filters.id_contact_receiver]
 * @param {number}  [filters.id_contact_emitter]
 * @param {string}  [filters.action_type]
 * @param {number}  [filters.id_conf_event]
 * @param {number}  [filters.limit=50]
 * @param {boolean} [filters.enabled=true]        — false pour désactiver le fetch
 */
export const useActivityLog = (filters = {}) => {
    const { enabled = true, ...queryFilters } = filters;
    const [logs, setLogs]       = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError]     = useState(null);

    const fetchLogs = useCallback(async () => {
        if (!enabled) return;
        setLoading(true);
        setError(null);
        try {
            const params = new URLSearchParams({ action: 'getActivityLogList' });
            Object.entries(queryFilters).forEach(([k, v]) => {
                if (v !== undefined && v !== null && v !== '') params.append(k, v);
            });
            const res  = await fetch(`${API_URL}?${params.toString()}`);
            const data = await res.json();
            setLogs(Array.isArray(data) ? data : []);
        } catch (e) {
            setError(e.message);
        } finally {
            setLoading(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled, JSON.stringify(queryFilters)]);

    useEffect(() => { fetchLogs(); }, [fetchLogs]);

    return { logs, loading, error, refresh: fetchLogs };
};
